import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import Loader from 'src/components/Loader';
import { useTranslation } from 'react-i18next';
import s from './JobFormStatusTab.styles';

const JobFormStatusTab = ({ jobStatus, loading, hasSaqService, hasUnverifiedSaqService, onClickWrapper }) => {
  const { t } = useTranslation();

  const getStatusRow = (
    label,
    timestamp,
    button,
    onClick,
    buttonAvailable,
    nextButtonAvailable,
  ) => {
    return loading ? (
      <Loader />
    ) : (
      <Fragment>
        {button !== 'Start' && buttonAvailable && (
          <s.DashRow>
            <td colSpan={3} />
          </s.DashRow>
        )}
        <s.StatusRow
          active={timestamp && !buttonAvailable && nextButtonAvailable}
        >
          <td>
            {timestamp ? (
              <s.StatusIcon name="check" />
            ) : (
              <s.StatusIcon name="dash" />
            )}
            {label}
          </td>
          <td>
            {timestamp ? (
              moment(timestamp).format('HH:mm, DD MMM YYYY')
            ) : (
              <span>—</span>
            )}
          </td>
          <td>
            {timestamp
              ? t('DONE')
              : button && (
                  <s.StatusButton
                    disabled={!buttonAvailable}
                    onClick={buttonAvailable ? onClick : undefined}
                    orange
                    sm
                    solid
                    type="button"
                  >
                    {button}
                  </s.StatusButton>
                )}
          </td>
        </s.StatusRow>
      </Fragment>
    );
  };

  return (
    <s.Table>
      <thead>
        <tr>
          <th>{t('STATE')}</th>
          <th>{t('TIMESTAMP')}</th>
          <th>{t('DETAILS_OPTIONAL')}</th>
        </tr>
      </thead>
      <tbody>
        {(hasSaqService || hasUnverifiedSaqService) && (<s.Title>{t('SAQ_PHASE')}</s.Title>)}
        {(hasSaqService || hasUnverifiedSaqService) && jobStatus
          .map(x => {
            return getStatusRow(x[0], x[1], x[2], x[3], x[4], x[5]);
          })
          .slice((hasUnverifiedSaqService ? 8: 11), (hasUnverifiedSaqService ? 10: 15))}
        {(!hasSaqService && !hasUnverifiedSaqService) && (<s.Title>{t('AUDIT_PHASE')}</s.Title>)}
        {(!hasSaqService && !hasUnverifiedSaqService) && jobStatus
          .map(x => {
            return getStatusRow(x[0], x[1], x[2], x[3], x[4], x[5]);
          })
          .slice(0, 5)}
        <s.Line />

        {!hasUnverifiedSaqService && <>
          <s.Title>{t('REVIEW_PHASE')}</s.Title>
          {jobStatus
            .map(x => {
              return getStatusRow(x[0], x[1], x[2], onClickWrapper(x[3]), x[4], x[5]);
            })
            .slice(5, 7)}
        </>}
      </tbody>
    </s.Table>
  );
};
JobFormStatusTab.propTypes = {
  onClickWrapper: PropTypes.func.isRequired,
  hasSaqService: PropTypes.bool,
  hasUnverifiedSaqService: PropTypes.bool,
  jobStatus: PropTypes.array,
  loading: PropTypes.bool
};

export default React.memo(JobFormStatusTab);
